// Drifting cloud decoration for the sky theme. Pure CSS animation —
// no Framer Motion needed. Honours `prefers-reduced-motion` via
// `.theme-decoration.no-motion` in index.css.
export function Clouds() {
  return (
    <div className="theme-decoration theme-decoration-clouds" aria-hidden="true">
      <span className="cloud cloud-a">☁️</span>
      <span className="cloud cloud-b">☁️</span>
      <span className="cloud cloud-c">☁️</span>
    </div>
  );
}
